/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_OutcomeInputs */

const cs_lustrace_history_outcome = /** @type {(inputs: Lustrace_History_OutcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výsledek`)
};

const en_lustrace_history_outcome = /** @type {(inputs: Lustrace_History_OutcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outcome`)
};

/**
* | output |
* | --- |
* | "Outcome" |
*
* @param {Lustrace_History_OutcomeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_outcome = /** @type {((inputs?: Lustrace_History_OutcomeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_OutcomeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_outcome(inputs)
	return cs_lustrace_history_outcome(inputs)
});